import { COPYRIGHT_ENGLISH } from "../constants.js";
export const fr = {
    "Notice": "Notice",
    "No slots available for the selected period.": "Aucun créneau disponible pour la période sélectionnée.",
    "welcome_back": "Bon retour",
    "login_subtitle": "Veuillez vous connecter pour continuer.",
    "login_tos_prefix": "En vous connectant, vous acceptez nos",
    "terms_of_service": "Conditions d'utilisation",
    "help": "Aide",
    "privacy": "Confidentialité",
    "imprint": "Mentions légales",
    "or": "ou",
    "google": "Google",
    "sso_icon_alt": "Icône SSO",
    "SSO": "SSO",
    "these_zesty_duck_nudge": "Informations de base",
    "north_least_gopher_burn": "Quel est l'objectif de ce type de rendez-vous ?",
    "lazy_just_duck_spin": "Titre de l'événement",
    "Confirm meeting": "Confirmer la réunion",
    "Meeting with {{name}}": "Réunion avec {{name}}",
    "Daily availability": "Disponibilité quotidienne",
    "tiny_factual_platypus_pave": "Où se déroule la réunion ?",
    "less_equal_octopus_dine": "Partie personnalisable de l'URL",
    "quiet_male_yak_slurp": "Slug de l'événement",
    "honest_weak_iguana_rest": "Lieu",
    "dizzy_quiet_walrus_hush": "super-reunion",
    "tired_whole_bumblebee_type": "Réunion Zoom",
    "these_moving_fox_create": "Description",
    "quaint_known_wasp_view": "Jours minimum à l'avance",
    "pretty_grand_cuckoo_arrive": "Les événements ne peuvent pas être programmés moins de ce temps à l'avance",
    "slow_maroon_spider_praise": "Nombre maximum d'événements de ce type par jour",
    "grand_wacky_ox_flow": "Maximum par jour",
    "left_aloof_stork_leap": "tampon-avant",
    "elegant_early_boar_accept": "Quelle est la durée de cet événement ?",
    "ideal_this_coyote_inspire": "Durée",
    "jumpy_tasty_rook_trust": "Durée",
    "real_big_crow_push": "Tampon avant cet événement",
    "mealy_happy_ray_flop": "Tampon avant",
    "close_actual_deer_boil": "Tampon après",
    "keen_zippy_bulldog_gaze": "Tampon après cet événement",
    "seemly_fine_octopus_slurp": "Disponibilité",
    "each_awake_tadpole_jest": "Modifier le type d'événement",
    "extra_patient_warbler_praise": "Aucun événement à réserver",
    "petty_swift_piranha_rise": "Programmer un événement",
    "broad_close_butterfly_drop": "Programmer un rendez-vous avec {{name}}",
    "weary_known_gazelle_file": "Veuillez sélectionner le type de rendez-vous dont vous avez besoin et cliquez sur le bouton de programmation pour le réserver. Vous obtiendrez une liste des créneaux disponibles dans mon emploi du temps.",
    "low_clean_haddock_bubble": "Mes types d'événements",
    "My Event Types": "Mes types d'événements",
    "pink_trite_ocelot_enrich": "Vous devez d'abord connecter votre calendrier avant de pouvoir ajouter des événements !",
    "early_sweet_mantis_peek": "Ajouter un type d'événement",
    "deft_suave_bear_pause": "Chargement",
    "equal_jolly_thrush_empower": " minutes",
    "Schedule Appointment": "Programmer un rendez-vous",
    "Available Meeting Types": "Types de réunion disponibles",
    "Please select a meeting type to view availability.": "Veuillez sélectionner un type de réunion pour voir les disponibilités.",
    "All": "Tous",
    "No public events found.": "Aucun événement public trouvé.",
    "Timezone": "Fuseau horaire",
    "Privacy & Terms": "Confidentialité et Conditions",
    "Quick": "Rapide",
    "Consulting": "Consultation",
    "Tags": "Étiquettes",
    "Type a tag and press Enter": "Tapez une étiquette et appuyez sur Entrée",
    "Press Enter to add a tag": "Appuyez sur Entrée pour ajouter une étiquette",
    "Cancel": "Annuler",
    "Contact": "Contact",
    "heroic_kind_llama_zip": "Retour",
    "awake_jolly_gazelle_lock": "Passer",
    "whole_acidic_parrot_promise": "Réserver un rendez-vous",
    "clear_close_racoon_pat": "{{value, dateTime}}",
    "cuddly_spare_felix_stir": "Étape {{val}}",
    "extra_misty_panda_grip": "Les utilisateurs peuvent utiliser ce lien pour réserver des rendez-vous.",
    "sunny_great_halibut_empower": "Créer le premier",
    "create_first_event_type_button": "Type d'événement",
    "application_title": "Appoint Me",
    "orange_grand_racoon_fall": "Comment fonctionne {{app_title}}",
    "male_patient_hedgehog_ask": "{{app_title}} est un système de prise de rendez-vous simple et facile à utiliser. Il vous permet de créer des événements, de partager votre lien et de permettre aux utilisateurs de prendre rendez-vous avec vous.",
    "factual_moving_hawk_belong": "Précisez où {{app_title}} ajoute vos rendez-vous et où il vérifie si vous êtes occupé.",
    "step_1_configure_calendars": "Étape 1 : Configurer les calendriers",
    "pink_polite_racoon_earn": "Étape 2 : Créer des événements",
    "happy_wise_mantis_laugh": "\"Ajoutez vos disponibilités et c'est parti !\"",
    "careful_misty_bullock_splash": "Étape 3 : Partager votre lien",
    "game_frail_vole_treasure": "Terminé ! Félicitations !",
    "still_helpful_koala_trust": "Une fois qu'un utilisateur prend rendez-vous, l'événement est ajouté à votre calendrier.",
    "steep_fine_lobster_inspire": "Échec de l'enregistrement du type d'événement",
    "best_due_parakeet_zip": "Type d'événement créé !",
    "happy_caring_fox_spur": "Événement enregistré",
    "tasty_witty_stingray_hope": "Erreur lors de l'enregistrement de l'événement",
    "trite_warm_gorilla_pet": "Ajouter des rendez-vous au calendrier",
    "aware_alert_mare_glow": "Vérifier le temps libre dans les calendriers",
    "factual_nimble_snail_clap": "Enregistrer les modifications",
    "tiny_teary_clownfish_vent": "Annuler",
    "lower_born_finch_dash": "Se déconnecter de Google",
    "whole_formal_liger_rise": "Connecter Google Calendar",
    "pink_loose_cougar_grin": "Mon calendrier",
    "upper_even_florian_peek": "Google Calendar",
    "merry_north_meerkat_cuddle": "Configuration",
    "big_known_loris_revive": "Choisissez les calendriers pour vérifier les heures occupées.",
    "large_suave_gull_hush": "copier le lien",
    "misty_proud_mallard_assure": "Copier le lien",
    "teal_lofty_hawk_peek": "Annuler",
    "mild_raw_elk_delight": "Enregistrer les modifications",
    "Choose date": "Choisir une date",
    "Please select a date": "Veuillez sélectionner une date",
    "Choose time": "Choisir une heure",
    "Provide details": "Fournir des détails",
    "Confirmation": "Confirmation",
    "Please share anything that will help me to prepare for our meeting": "Veuillez partager tout ce qui m'aidera à me préparer pour notre réunion",
    "confirmationText_male": "Vous avez réservé un rendez-vous {{event}} avec {{name}} le {{date}} à {{time}}.",
    "confirmationText_female": "Vous avez réservé un rendez-vous {{event}} avec {{name}} le {{date}} à {{time}}.",
    "confirmationText_neuter": "Vous avez réservé un rendez-vous {{event}} avec {{name}} le {{date}} à {{time}}.",
    "Name": "Nom",
    "Please provide your name": "Veuillez fournir votre nom",
    "Email": "E-mail",
    "Information": "Information",
    "You will receive a confirmation email": "Vous recevrez un e-mail de confirmation",
    "Meeting with": "Réunion avec",
    "Change": "Modifier",
    "Schedule an appointment": "Prendre un rendez-vous",
    "edit": "Modifier",
    "Back": "Retour",
    "Add Event Type": "Ajouter un type d'événement",
    "Confirm & Book": "Confirmer et réserver",
    "availableSlots": "Les créneaux suivants sont disponibles le {{date}}. Réservez-en un ou choisissez un autre jour.",
    "minutes": "minutes",
    "Days": "Jours",
    "Maximum days in advance": "Jours maximum à l'avance",
    "event_advance_availability_description": "Combien de jours à l'avance ce type d'événement est-il disponible ?",
    "none": "Aucun",
    "Select buffer": "Sélectionner un tampon",
    "Save": "Enregistrer",
    "Select duration": "Sélectionner une durée",
    "Starttime": "Heure de début",
    "Endtime": "Heure de fin",
    "Add Account": "Ajouter un compte",
    "Add CalDav Account": "Ajouter un compte CalDav",
    "CalDav Accounts": "Comptes CalDav",
    "Server URL": "URL du serveur",
    "Username": "Nom d'utilisateur",
    "label_password": "Mot de passe",
    "send_invitation_email": "Send invitation email",
    "send_invitation_email_notice": "Only needed if your CalDAV server does not send invitations automatically.",
    "invitationSubject": "Invitation : {{summary}}",
    "invitationBody": "<p>Bonjour {{attendeeName}},</p><p>Vous avez été invité à l'événement suivant :</p><h3>{{summary}}</h3><p>{{description}}</p><p><strong>Heure :</strong> {{time}}</p><p>Veuillez trouver les détails de l'événement ci-joint.</p>",
    "icsDescription": "Description de l'événement :\n{{description}}",
    "dateFormat": "fr-FR",
    "user_menu_log_out": "Se déconnecter",
    "user_menu_log_in": "Se connecter",
    "user_menu_profile": "Profil",
    "user_menu_my_account": "Mon compte",
    "user_menu_calendar_integration": "Intégration du calendrier",
    "user_menu_copy_link": "Copier le lien",
    "user_menu_link_copied": "Lien copié",
    "name": "Nom",
    "user_url": "URL utilisateur",
    "use_gravatar": "Utiliser Gravatar",
    "save": "Enregistrer",
    "profile_updated": "Profil mis à jour avec succès",
    "error_saving_profile": "Erreur lors de l'enregistrement du profil",
    "user_url_taken": "URL utilisateur déjà prise",
    "error_loading_profile": "Erreur lors du chargement du profil",
    "login_with_sso": "Se connecter avec SSO",
    "login_with": "Se connecter avec",
    "login_successful": "Connexion réussie",
    "login_failed": "Échec de la connexion",
    "google_login_failed": "Échec de la connexion Google",
    "Add": "Ajouter",
    "Close": "Fermer",
    "Choose calendars in which appointments are created.": "Choisissez les calendriers dans lesquels les rendez-vous sont créés.",
    "Email (Optional)": "E-mail (Facultatif)",
    "Enter your CalDav server details to connect your calendar.": "Entrez les détails de votre serveur CalDav pour connecter votre calendrier.",
    "Failed to add account. Please check your credentials and server URL.": "Impossible d'ajouter le compte. Veuillez vérifier vos identifiants et l'URL du serveur.",
    "I acknowledge that my password will be stored encrypted in the database.": "Je reconnais que mon mot de passe sera stocké chiffré dans la base de données.",
    "event_copy_link": "Copier le lien",
    "link_copied_to_clipboard": "Lien copié dans le presse-papiers !",
    "link_copy_failed": "Impossible de copier le lien dans le presse-papiers !",
    "copy": "Copier",
    "Availability Mode": "Mode de disponibilité",
    "Define Custom": "Définir personnalisé",
    "Use Standard": "Utiliser standard",
    "Standard + Extra": "Standard + Supplément",
    "Standard + Constraints": "Standard + Contraintes",
    "Standard Availability": "Disponibilité standard",
    "Using Standard Availability defined in Profile settings.": "Utilise la disponibilité standard définie dans les paramètres du profil.",
    "Define your standard weekly availability here. You can use this availability in your Event Types.": "Définissez ici votre disponibilité hebdomadaire standard. Vous pouvez utiliser cette disponibilité dans vos types d'événements.",
    "Copy Standard Availability": "Copier la disponibilité standard",
    "Overwrite current availability with standard?": "Remplacer la disponibilité actuelle par la standard ?",
    "Profile": "Profil",
    "about": "À propos",
    "about_content": "# À propos d'AppointMe\n\nAppointMe est un outil simple pour la prise de rendez-vous.\nConfigurez vos calendriers, définissez vos disponibilités et laissez les autres prendre rendez-vous avec vous.\n\n## Github\n[Voir le code sur Github](https://github.com/fhswf/appointme)\n\n## Crédits\nMis en œuvre avec ❤️ à l'Université des Sciences Appliquées de South Westphalia",
    "legal": "Mentions légales",
    "Calendar": "Calendrier",
    "Select a calendar": "Sélectionner un calendrier",
    "No calendar selected": "Aucun calendrier sélectionné",
    "Calendar settings saved": "Paramètres du calendrier enregistrés",
    "Failed to save settings": "Échec de l'enregistrement des paramètres",
    "Failed to load calendars for": "Impossible de charger les calendriers pour",
    "Google Calendar disconnected": "Google Agenda déconnecté",
    "Failed to disconnect Google Calendar": "Impossible de déconnecter Google Agenda",
    "Connect a calendar to get started": "Connectez un calendrier pour commencer",
    "Online via Zoom": "En ligne via Zoom",
    "Language": "Langue",
    "page not found": "Page non trouvée",
    "GO HOME": "ACCUEIL",
    "Impressum": "Mentions légales",
    "Datenschutzhinweise": "Politique de confidentialité",
    "privacy_content": `
# Politique de confidentialité

## Collecte et utilisation des données
Cette application collecte et utilise des données personnelles pour fournir des services de prise de rendez-vous.

*   **Profil utilisateur:** Nous stockons votre nom, votre adresse e-mail et votre photo de profil pour vous identifier et personnaliser votre expérience.
*   **Données utilisateur Google:** Si vous connectez votre Google Agenda, nous accédons aux données de votre agenda pour :
    *   Vérifier vos disponibilités pour éviter les doubles réservations.
    *   Créer de nouveaux événements dans votre agenda lorsqu'un rendez-vous est pris.
    *   Nous n'utilisons **pas** vos données Google Agenda à d'autres fins, telles que la publicité ou les études de marché.
*   **Données d'agenda:** Nous stockons les paramètres de configuration de vos agendas connectés, les types d'événements que vous créez (nom, description, lieu) et les réservations de rendez-vous.
*   **Données de journal:** Votre adresse IP est stockée temporairement dans les fichiers journaux du serveur à des fins de sécurité et de dépannage.
*   **Télémétrie:** Nous collectons des données d'utilisation anonymes et des rapports d'erreurs en utilisant Sentry pour améliorer la stabilité de l'application.

## Partage des données
Nous ne partageons pas vos données personnelles avec des tiers, sauf si cela est nécessaire pour fournir le service ou si la loi l'exige.

*   **Données utilisateur Google:** Les données obtenues à partir des API Google ne sont **pas partagées** avec des outils tiers, des modèles d'IA ou des entités externes, sauf si cela est nécessaire pour fournir les fonctionnalités d'intégration de l'agenda (par exemple, communiquer avec les serveurs de Google).
*   **Fournisseurs de services:** Nous utilisons Sentry pour le suivi des erreurs et la surveillance des applications afin d'assurer la stabilité du service. Ce fournisseur peut traiter les adresses IP et d'autres données techniques strictement pour la fourniture du service.
*   **Hébergement:** L'application est hébergée sur notre propre infrastructure (cluster Kubernetes). Nous n'utilisons pas de CDN tiers ou de fournisseurs d'hébergement qui auraient ainsi accès à vos données.

## Stockage et protection des données
Vos données sont stockées en toute sécurité sur nos serveurs.
*   **Chiffrement:** Toutes les données transmises entre votre navigateur et nos serveurs sont chiffrées via HTTPS. Les données sensibles telles que les jetons d'accès sont stockées chiffrées dans notre base de données.
*   **Contrôle d'accès:** L'accès à vos données est restreint au personnel autorisé et n'est accessible que lorsque cela est nécessaire pour le support ou la maintenance.

## Conservation et suppression des données
*   **Conservation:** Nous conservons votre profil utilisateur et les données de configuration de votre agenda tant que votre compte est actif. Les données de rendez-vous sont conservées pour vous fournir un historique de vos événements programmés.
*   **Suppression:** Vous avez le droit de demander la suppression de vos données. Vous pouvez déconnecter votre Google Agenda à tout moment via les paramètres de l'application, ce qui supprimera notre accès à vos données Google. Pour demander la suppression complète de votre compte et de vos données, veuillez nous contacter à gawron.christian@fh-swf.de ou utiliser la fonctionnalité de suppression de compte dans les paramètres de votre profil.

## Politique relative aux données utilisateur des services API de Google
L'utilisation et le transfert par AppointMe vers toute autre application des informations reçues des API Google respecteront la [Politique relative aux données utilisateur des services API de Google](https://developers.google.com/terms/api-services-user-data-policy), y compris les exigences d'utilisation limitée.`,
    "privacy_content_public": `
# Politique de confidentialité

## Traitement des données

Dans le but de réserver un rendez-vous, cette application traite les données que vous fournissez (nom, adresse e-mail, description, date et heure du rendez-vous). Ces données sont stockées pour gérer le rendez-vous et peuvent être synchronisées avec le calendrier de l'organisateur.

## Télémétrie

Nous utilisons Sentry pour collecter des données télémétriques anonymes et des rapports d'erreurs afin d'améliorer la stabilité de l'application.`,
    "impressum_content": "# Mentions légales\n\n## Avis de non-responsabilité\nLe contenu de ce serveur ne fait pas partie de l'offre en ligne officielle de l'Université des Sciences Appliquées de South Westphalia.",
    "CalDav Calendar": "Calendrier CalDav",
    "loading": "Chargement...",
    "Legal": "Mentions légales",
    "new_event_type": "Nouveau type d'événement",
    "Appointment Summary": "Résumé du rendez-vous",
    "Could not book event": "Impossible de réserver l'événement",
    "error_no_calendar": "Aucune intégration de calendrier configurée",
    "error_no_duration": "La durée doit être supérieure à 0",
    "error_no_slots": "Aucun créneau horaire configuré",
    "Active": "Actif",
    "Inactive": "Inactif",
    "delete": "Supprimer",
    "Continue": "Continuer",
    "Book Appointment": "Réserver un rendez-vous",
    "Available Times": "Horaires disponibles",
    "No slots available": "Aucun créneau disponible",
    "landing_hero_title": "Appointment management <span class=\"text-primary\">made easy</span>",
    "landing_hero_subtitle": "Appoint Me is a simple and user-friendly solution for your appointments. Create events, share your link, and let others book appointments with you.",
    "landing_cta_start": "Start now",
    "landing_cta_learn_more": "Learn more",
    "landing_how_it_works_title": "How Appoint Me works",
    "landing_how_it_works_subtitle": "In just four simple steps to your organized calendar.",
    "landing_step1_title": "1. Configure calendar",
    "landing_step1_desc": "Determine where Appoint Me should enter appointments and where your availability should be checked. Connect your Google or Outlook calendar.",
    "landing_step2_title": "2. Create events",
    "landing_step2_desc": "Add your available times, define duration and break times, and get started!",
    "landing_step3_title": "3. Share your link",
    "landing_step3_desc": "Via your personal link, customers, colleagues, or friends can book appointments directly without annoying email ping-pong.",
    "landing_step4_title": "Done! Congrats!",
    "landing_step4_desc": "As soon as a user books an appointment, the event is automatically added to your calendar and both receive a confirmation.",
    "landing_footer_product": "Product",
    "landing_footer_features": "Features",
    "landing_footer_pricing": "Pricing",
    "landing_footer_integrations": "Integrations",
    "landing_footer_resources": "Resources",
    "landing_footer_documentation": "Documentation",
    "landing_footer_api": "API",
    "landing_footer_help_center": "Help Center",
    "landing_footer_legal": "Legal",
    "landing_footer_imprint": "Imprint",
    "landing_footer_privacy": "Privacy",
    "landing_footer_terms": "Terms & Conditions",
    "landing_footer_copyright": COPYRIGHT_ENGLISH,
    "landing_footer_tagline": "Simple appointment planning for everyone.",
    "footer_credits": "Mis en œuvre avec ❤️ à l'Université des Sciences Appliquées de South Westphalia",
    "terms_of_use_title": "Terms of Use",
    "terms_of_use_content": "# Terms of Use\n\n## Service Provision\n\nThis service is provided free of charge.\n\n## Disclaimer of Liability and Warranty\n\nNeither the authors nor the South Westphalia University of Applied Sciences accept any liability for damages of any kind or any warranty of any kind in connection with the use of this service. Use is at your own risk. This disclaimer does not apply to damages resulting from injury to life, body, or health based on an intentional or negligent breach of duty, nor to other damages based on an intentional or grossly negligent breach of duty.",
    "my_appointments": "Mes Rendez-vous",
    "no_upcoming_appointments": "Aucun rendez-vous à venir trouvé.",
    "appointment": "Rendez-vous",
    "attendee": "Participant",
    "appointment_details": "Détails du Rendez-vous",
    "close": "Fermer",
    "event_type": "Type d'événement",
    "week": "Semaine",
    "work_week": "Semaine de travail",
    "day": "Jour",
    "month": "Mois",
    "today": "Aujourd'hui",
    "agenda": "Agenda",
    "more": "plus",
    "next": "Suivant",
    "back": "Retour",
    "n_more": "{{count}} autres ...",
    "Recurrence": "Récurrence",
    "Enable Recurring Event": "Activer l'événement récurrent",
    "Frequency": "Fréquence",
    "Weekly": "Hebdomadaire",
    "Bi-weekly": "Bi-hebdomadaire",
    "Tri-weekly": "Tri-hebdomadaire",
    "Monthly": "Mensuel",
    "End Condition": "Condition de fin",
    "Occurrences": "Occurrences",
    "OR": "OU",
    "Until Date": "Date de fin",
    "Time Span": "Durée",
    "Months": "Mois",
    "Weeks": "Semaines",
    "Recurring Event": "Événement récurrent",
    "Recurring": "Récurrent",
    "weekly": "Hebdomadaire",
    "biweekly": "Bi-hebdomadaire",
    "triweekly": "Tri-hebdomadaire",
    "monthly": "Mensuel",
    "Series Booking Note: Students will book all occurrences at once.": "Note de réservation de série : Les étudiants réserveront toutes les occurrences en une seule fois.",
    "Feedback": "Retour d'information",
    "Student Only": "Étudiants uniquement",
    "Restricted to Students": "Réservé aux étudiants",
    "Settings exported successfully": "Paramètres exportés avec succès",
    "Failed to export settings": "Échec de l'exportation des paramètres",
    "Are you sure you want to import settings? This will overwrite your current profile and events.": "Êtes-vous sûr de vouloir importer des paramètres ? Cela écrasera votre profil et vos événements actuels.",
    "Settings imported successfully": "Paramètres importés avec succès",
    "Failed to import settings": "Échec de l'importation des paramètres",
    "Invalid file format": "Format de fichier non valide",
    "Data": "Données",
    "Export Settings": "Exporter les paramètres",
    "Download your settings and events as a JSON file.": "Téléchargez vos paramètres et événements sous forme de fichier JSON.",
    "Export Data": "Exporter les données",
    "Import Settings": "Importer les paramètres",
    "Restore your settings from a JSON file. This will overwrite existing data.": "Restaurez vos paramètres à partir d'un fichier JSON. Cela écrasera les données existantes.",
    "Select File": "Sélectionner un fichier",
    "Online Meeting": "Réunion en ligne",
    "You are logged in via your Learning Management System. Please use the specific booking links provided in your course to book appointments.": "Vous êtes connecté via votre système de gestion de l'apprentissage. Veuillez utiliser les liens de réservation spécifiques fournis dans votre cours pour prendre rendez-vous.",
    "Logout": "Se déconnecter",
    "MyProvider": "Mon fournisseur",
    "Grammatical Gender": "Genre grammatical",
    "Male": "Masculin",
    "Female": "Féminin",
    "Neuter": "Neutre",
    "gender_help_text": "Utilisé pour une grammaire correcte dans les messages de confirmation.",
    "Changelog": "Changelog",
    "Failed to load changelog data.": "Impossible de charger les données du journal des modifications.",
    "See what's new and what has been fixed.": "Découvrez les nouveautés et les corrections apportées.",
    "Reminder setting": "Paramètre de rappel",
    "Notification type": "Type de notification",
    "System notification": "Notification système",
    "No reminder": "Aucun rappel",
    "Reminder time": "Heure du rappel",
    "Reminder settings saved": "Paramètres de rappel enregistrés",
    "At event start": "Au début de l'événement",
    "minutes before": "minutes avant",
    "1 day before": "1 jour avant",
    "days before": "jours avant",
    "1 hour before": "1 heure avant",
    "hours before": "heures avant"
};
//# sourceMappingURL=fr.js.map